import React, { useState } from "react";
import { useEffect } from "react";

export default function Contact() {
  useEffect(() => {
  document.title = "Contact | HD Labs";
}, []);

  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Replace with API logic
    setSubmitted(true);
  };

  return (
    <section className="relative bg-white py-20 px-4 sm:px-6 lg:px-8 text-gray-900">
      <div className="mx-auto max-w-3xl">
        {/* Header */}
        <div className="text-center">
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight">
            Let’s Connect
          </h2>
          <p className="mt-3 text-gray-600 text-sm sm:text-base max-w-2xl mx-auto">
            Have questions about our products, research, or collaborations? Our team is ready to help. Reach out and we’ll respond promptly.
          </p>
        </div>

        {/* Form */}
        <div className="mt-10 bg-gray-50 rounded-2xl shadow-sm p-6 sm:p-10">
          {submitted ? (
            <div className="text-center">
              <h3 className="text-xl font-semibold text-gray-900">Thank you!</h3>
              <p className="mt-2 text-gray-600">
                Your message has been received. We’ll get back to you shortly.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-blue-600 transition text-sm"
                  placeholder="Your name"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-blue-600 transition text-sm"
                  placeholder="you@example.com"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                  Message
                </label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  rows={4}
                  required
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-blue-600 transition text-sm"
                  placeholder="Write your message..."
                />
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  className="inline-flex items-center justify-center rounded-lg bg-blue-900 text-white font-semibold px-5 py-2 text-sm sm:text-base hover:bg-blue-800 transition"
                >
                  Send Message
                </button>
              </div>
            </form>
          )}
        </div>

        {/* Contact Info */}
        <div className="mt-8 text-center space-y-1">
          <p className="text-gray-500 text-xs sm:text-sm">Or reach us directly at:</p>
          <p className="font-medium text-gray-900 text-sm sm:text-base">info@hdlabs.ca</p>
        </div>
      </div>
    </section>
  );
}